<h2>Upload a video</h2>
<div *ngIf="previewUrl">
  <hr/>
  <h4>Preview video</h4>
  <video *ngIf="previewUrl" [src]="previewUrl" height="300" controls></video>
</div>
<h5 *ngIf="previewUrl && selectedFile">{{selectedFile.name}}</h5>
<hr/>
<div class="card-container">
  <div class="upload-btn-wrapper">
    <button class="btn">{{previewUrl ? 'Select another file' : 'Select a file'}}</button>
      <!--    <input type='file' accept=".mp4,.webm,.avi" (change)="onSelectFile($event)"/>-->
      <input type='file' accept=".mp4,.webm,.avi" disabled/>
      <br/><br/><span style="color: red">It has been deactivated.</span>
  </div>
</div>
<div *ngIf="previewUrl">
  <hr/>
  <div class="card-container">
    <div class="card card-small" (click)="uploadVideo()" tabindex="0">
      <span>Upload & analyze video</span>
    </div>
  </div>
  <div class="card-container" *ngIf="isBusy">
    <div class="lds-dual-ring"></div>
  </div>
  <br *ngIf="isBusy"/>
</div>
<div *ngIf="downloadUrl">
  <hr/>
  <h4>Analyzed video</h4>
  <video [src]="downloadUrl" *ngIf="downloadUrl" height="300" controls></video>
  <br/><br/>
  <div class="card-container">
    <div class="card card-small" (click)="download()" tabindex="0">
      <span>Download</span>
    </div>
  </div>
</div>
